export interface Category {
  id: string;
  name: string;
}

// A subset of categories, sorted alphabetically
export const allCategoriesData: Category[] = [
  // Original 8 categories
  { id: "ai", name: "AI" },
  { id: "defi", name: "DeFi" },
  { id: "gaming", name: "Gaming" },
  { id: "layer-1", name: "Layer 1" },
  { id: "layer-2", name: "Layer 2" },
  { id: "meme", name: "Meme" },
  { id: "nft", name: "NFT" },
  { id: "social", name: "Social" },

  // New 10 high-significance level-1 categories
  { id: "bitcoin-ecosystem", name: "Bitcoin Ecosystem" },
  { id: "ethereum-ecosystem", name: "Ethereum Ecosystem" },
  { id: "binance-smart-chain", name: "BNB Chain Ecosystem" },
  { id: "solana-ecosystem", name: "Solana Ecosystem" },
  { id: "polkadot-ecosystem", name: "Polkadot Ecosystem" },
  { id: "cardano-ecosystem", name: "Cardano Ecosystem" },
  { id: "payment-solutions", name: "Payment Solutions" },
  { id: "oracle", name: "Oracle" },
  { id: "storage", name: "Storage" },
  { id: "privacy-coins", name: "Privacy" }, 
].sort((a, b) => a.name.localeCompare(b.name));

export const CATEGORIES_TO_SHOW_INITIALLY = 10;
